import { showHpaNotAllowedModal, startHpa } from '../../hpa/actions';
import {
  ACTIVE,
  NOT_ALLOWED,
} from '../../../definitions/HPAConstants';
import {
  applicationInitializationFailed,
  applicationInitialized,
} from '../../application/actions';
import { omit } from 'lodash';
import SessionUtils from '../../../utils/SessionUtils';
import { uiResize } from '../../ui/actions';
import WindowUtils from '../../../utils/WindowUtils';
import { receiveContacts } from '../contact/actions';
import { receiveSessionStarted } from '../../session/actions';
import moment from 'moment';

const createActionName = require('../../util').createActionName('user');

export const INITIALIZE_USER_INFO = createActionName('INITIALIZE_USER_INFO');
export const SET_LOGGED_IN = createActionName('SET_LOGGED_IN');
export const SET_IS_USER = createActionName('SET_IS_USER');
export const INITIALIZE_AGREEMENT_USER_INFO = createActionName(
  'INITIALIZE_AGREEMENT_USER_INFO'
);
export const GET_USER_INFO = createActionName('GET_USER_INFO');
export const RECEIVE_USER_INFO = createActionName('RECEIVE_USER_INFO');
export const GET_USER_INFO_FAILED = createActionName('GET_USER_INFO_FAILED');

export const SET_TOS_VERSION = createActionName('SET_TOS_VERSION');

export const initializeUserInfo = (userInfo) => ({
  type: INITIALIZE_USER_INFO,
  payload: { userInfo },
});

export const setLoggedIn = (loggedIn) => ({
  type: SET_LOGGED_IN,
  payload: { loggedIn },
});

export const setIsUser = (isUser) => ({
  type: SET_IS_USER,
  payload: { isUser },
});

export const initializeAgreementUserInfo = (agreementUserInfo) => ({
  type: INITIALIZE_AGREEMENT_USER_INFO,
  payload: { agreementUserInfo },
});

export const getUserInfo = () => ({
  type: GET_USER_INFO,
});

export const receiveUserInfo = (data) => ({
  type: RECEIVE_USER_INFO,
  payload: { data },
});

export const getUserInfoFailed = (error) => ({
  type: GET_USER_INFO_FAILED,
  payload: { error },
});

export const setTosVersion = (data) => ({
  type: SET_TOS_VERSION,
  payload: { data },
});

export const updateUserInfo = () => (dispatch, getState, services) => {
  return new Promise((resolve, reject) => {
    dispatch(getUserInfo());
    return services.api
      .getUserInfo()
      .then((data) => {
        return resolve(dispatch(initializeUserInfo(data)));
      })
      .catch((error) => {
        console.log(error);
        return reject(dispatch(getUserInfoFailed(error)));
      });
  });
};

const initializeUser = async (dispatch, services) => {
  try {
    const userData = await services.api.init();

    dispatch(setLoggedIn(userData.loggedIn));
    dispatch(setIsUser(userData.isUser));
    dispatch(setTosVersion(userData.tosVersion));
    dispatch(
      receiveSessionStarted(moment.unix(userData.authenticationInstant))
    );

    // check whether user has filled the agreement form
    if (userData.isUser) {
      dispatch(initializeUserInfo(omit(userData.userInfo, 'contacts')));
      dispatch(receiveContacts(userData.userInfo.contacts));
    } else {
      dispatch(initializeAgreementUserInfo(userData.agreementUserInfo));
    }

    if (userData.hpaState === ACTIVE && userData.hpaSessionId) {
      dispatch(startHpa(userData.hpaSessionId));
    }

    if (userData.hpaState === NOT_ALLOWED) {
      dispatch(showHpaNotAllowedModal());
    }
  } catch (err) {
    if (err && err.code === 'EIDAS_USER') {
      SessionUtils.logout({ internalLogoutReason: 'EIDAS_USER' });
    } else {
      dispatch(applicationInitializationFailed());
      throw new Error(err);
    }
  }
}

export const initializeApplication = () => (dispatch, _, services) => {
  window.addEventListener('resize', () =>
    dispatch(uiResize(WindowUtils.screenWidth()))
  );

  return new Promise((resolve, reject) => {
    initializeUser(dispatch, services)
      .then(() => {
        resolve(dispatch(applicationInitialized()));
      })
      .catch((error) => {
        reject(error);
      })
  });
}

